import React, { useState, useEffect, useContext } from "react";
// import { Editor } from "react-draft-wysiwyg";
import { ProductService } from "../../../services/product-service";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import { ToastContainer } from "react-toastify";
import { DataGrid } from "@material-ui/data-grid";
import { TablePagination } from "@material-ui/core";
import AuthContext from "../../../context/auth-context";
import { Modal } from "react-bootstrap";
import { GdnService } from "../../../services/gdn-service";


export const GdnItems = (props) => {
  const ctx = useContext(AuthContext);

  const authPermission = localStorage.getItem("PermissionDetails");

  const [editHide, setHideEdit] = useState(true);
  const [deleteHide, setHideDelete] = useState(true);

  useEffect(() => {
    JSON.parse(authPermission).forEach(function (loca) {
      if (
        loca.access_module.module_name == "DISPATCH" &&
        loca.permission_edit === true
      ) {
        setHideEdit(false);
      }
      if (
        loca.access_module.module_name == "DISPATCH" &&
        loca.permission_delete === true
      ) {
        setHideDelete(false);
      }
    });
  }, [authPermission]);

  const [submitloading, setSubmitLoading] = useState(true);

  const [state, setState] = useState(false);

  const [gdnItemID, setGdnItemID] = useState(0);


  const handleShow4 = (e) => {
    setState({ show4: true });
    setGdnItemID(e);
  };

  const handleClose = (e) => {
    setState({ show3: false });
  };

  let allItems = props.gdnItemsInfo
  const [ gdnItems, setGdnItems] = useState([]);

  const [products, setProducts] = useState([]);

  //add product data into group product
  const loadProduct = async (allItems) =>{
    try{
      const itemsData = allItems
      let finalArray = [];
      finalArray = await Promise.all(itemsData.map(async (product) => {
        const result = await ProductService.productDetailsID(product.product_id);
        product["product_name"] = result.name;
        return product;
      }))
      setGdnItems(finalArray);
    }catch (err) {
      //toast
      console.error(err);
    }
    
  }

  const productDetailsSearch = async () => {
    try {
      const result = await ProductService.productDetailsAllSearch();

      setProducts(result.results);
    } catch (err) {
      //toast
      console.error(err);
    }
  };

  useEffect(() => {
    productDetailsSearch();
  }, []);

  useEffect(() => {
    loadProduct(allItems);
  },[allItems])


  const onDelete = async () => {
    //todo extra validations
    setSubmitLoading(false);
    try {
      await GdnService.gdnItemDelete(gdnItemID);

      setSubmitLoading(true);
      notify("GDN item successfully deleted");
      handleClose();
    } catch (err) {
      notifyWarning(err.response.data.message);
      setSubmitLoading(true);
      //show error toast
    }
  };

  const columns = [
    {
      field: "id",
      headerName: "ID",
      flex: 1,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    {
      field: "product.name",
      headerName: "Product Name",
      flex: 4,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return <div>{params.row.product.name}</div>;
      },
    },
    {
      field: "quantity",
      headerName: "Quantity",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerAlign: "center",  // Aligns the header text
      align: "center",
    },
    {
      field: "unit_price",
      headerName: "Unit Price",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerAlign: "center",  // Aligns the header text
      align: "center",
      valueFormatter: (params) => {
        return new Intl.NumberFormat("en-US", {
          style: "decimal",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(params.value);
      },
    },
    {
      field: "discount_percentage",
      headerName: "Discount",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerAlign: "center",  // Aligns the header text
      align: "center",
    },
    {
      field: "line_total",
      headerName: "Line Total",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerAlign: "center",  // Aligns the header text
      align: "center",
      valueFormatter: (params) => {
        return new Intl.NumberFormat("en-US", {
          style: "decimal",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(params.value);
      },
    },
    
  ];

  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="ms-panel">
            <div>
              <Modal
                show={state.show4}
                onHide={handleClose}
                aria-labelledby="contained-modal-title-vcenter"
                centered
              >
                <Modal.Header>
                  <h3 className="modal-title has-icon ms-icon-round ">
                    Confirm Deletion
                  </h3>
                  <button type="button" className="close" onClick={handleClose}>
                    <span aria-hidden="true">×</span>
                  </button>
                </Modal.Header>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "2vh",
                  }}
                >
                  <h6 style={{ color: "red" }}>
                    Are you sure you want to remove this item ?
                  </h6>
                </div>
                <Modal.Footer>
                  <div className="col-md-2" hidden={submitloading}>
                    <div className="spinner spinner-7">
                      <div className="bounce1" />
                      <div className="bounce2" />
                      <div className="bounce3" />
                    </div>
                  </div>
                  <button
                    type="button"
                    className="btn btn-primary shadow-none"
                    style={{ backgroundColor: "red" }}
                    onClick={onDelete}
                  >
                    Delete
                  </button>

                  <button
                    type="button"
                    className="btn btn-light"
                    onClick={handleClose}
                  >
                    Cancel
                  </button>
                </Modal.Footer>
              </Modal>
            </div>
            <div className="ms-panel-body">
              <div style={{ width: "100%" }}>
                <DataGrid
                  rows={gdnItems}
                  columns={columns}
                  hideFooter
                  autoHeight
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

};

export default GdnItems;
